class ProductMedia extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.layout = this.dataset.layout),
      (this.masonry_container = this.querySelector("[data-masonry-layout]")),
      (this.media = this.querySelectorAll(".product-media--root")),
      (this.modal = this.querySelector('[data-modal-view="product-media"]')),
      (this.playable_media = this.querySelectorAll(
        ".product-model--root, .product-video--root"
      )),
      (this.scroll_enabled =
        "true" == this.getAttribute("data-variant-scroll")),
      this.pauseListener(),
      this.updateMediaListeners(),
      this.masonry_container &&
        ((this.gap = parseInt(this.masonry_container.dataset.gap)),
        this.getMasonryBlocks(),
        this.resizeObserver());
  }
  disconnectedCallback() {
    this.playable_media.off("click." + this.dataset.id),
      window.off(
        `theme:product:${this.dataset.id}:variantChanged.ProductMedia theme:product:${this.dataset.id}:mediaChanged.ProductMedia`
      );
  }
  pauseListener() {
    this.playable_media.on("click." + this.dataset.id, ({ target: t }) => {
      var e = t.closest(".product-model--root, .product-video--root");
      this.playable_media.not(e).forEach((t) => t.trigger("pauseMedia"));
    });
  }
  updateMediaListeners() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged.ProductMedia`,
      ({ detail: { variant: t } }) => {
        var e = t.featured_media ? parseInt(t.featured_media.id) : 0;
        this.updateVariantMedia(e);
      console.log(t.featured_media.alt);
        const variant_color = t.featured_media.alt;
        // Get all elements with class .product-media--root
        const productMediaElements = document.querySelectorAll('.product-media--root');
        const productThumbElements = document.querySelectorAll('.product-media--thumb');
        
        // Loop through each element
        productMediaElements.forEach(element => {
            const dataMediaAltValue = element.getAttribute('data-media-alt');
            
            // Check if the data-media-alt value matches the variant_color
          if (variant_color != "" && variant_color != null){
            if (dataMediaAltValue === variant_color) {
                // Show the element
                element.style.display = 'block';
            } else {
                // Hide the element
                element.style.display = 'none';
            }
          }
          else{
            element.style.display = 'block';
          }
        });
         productThumbElements.forEach(element => {
        const dataThumbAltValue = element.getAttribute('data-media-alt');

        // Check if the data-media-alt value matches the variant_color
      if (variant_color != "" && variant_color != null){
        if (dataThumbAltValue === variant_color) {
            // Show the element
            element.style.display = 'block';
        } else {
            // Hide the element
            element.style.display = 'none';
        }
      }
      else{
        element.style.display = 'block';
      }
    });
      }
    ),
      window.on(
        `theme:product:${this.dataset.id}:mediaChanged.ProductMedia`,
        ({ detail: { id: t } }) => this.updateVariantMedia(t)
      );
  }
  updateVariantMedia(a) {
    0 !== a &&
      this.media.forEach((t) => {
        var e = parseInt(t.dataset.id) === a;
        t.setAttribute("data-active", e),
          t.children[0].trigger(e ? "playMedia" : "pauseMedia"),
          e &&
            ("one" == this.layout || "two" == this.layout
              ? this.scrollToMedia(parseInt(t.offset().top))
              : ("mixed" == this.layout && this.updateMixedMedia(t),
                this.scrollToMedia(parseInt(this.offset().top))));
      });
  }
  scrollToMedia(t) {
    var e, a;
    this.scroll_enabled &&
      "small" !== theme.mqs.current_window &&
      "thumbnails" != this.layout &&
      ((a =
        "" ===
        (e = document.documentElement.style.getPropertyValue("--sticky-offset"))
          ? 0
          : parseInt(e.replace("px", ""))),
      window.scrollTo({ top: t - a - 8, left: 0, behavior: "smooth" }));
  }
  updateMixedMedia(t) {
    var e = this.querySelector(".product-media--active .product-media--root");
    e &&
      (this.swapMedia(t, e),
      (this.media = this.querySelectorAll(".product-media--root"))),
      this.masonry_container && this.getMasonryBlocks(),
      this.modal && this.updateModals(t.dataset.id);
  }
  updateModals(e) {
    var t = this.querySelectorAll(".modal--content"),
      a = [...t].find((t) => e === t.dataset.id);
    this.modal.updateLinks(), a && this.swapMedia(t[0], a);
  }
  swapMedia(t, e) {
    t.replaceWith(e.cloneNode(!0)), e.replaceWith(t.cloneNode(!0));
  }
  getMasonryBlocks() {
    (this.left_blocks = this.masonry_container.querySelectorAll(
      ":scope > :nth-child(odd)"
    )),
      (this.right_blocks = this.masonry_container.querySelectorAll(
        ":scope > :nth-child(even)"
      )),
      this.setMasonryLayout();
  }
  setMasonryLayout() {
    var t = this.getColumnHeight(this.left_blocks),
      e = this.getColumnHeight(this.right_blocks),
      a =
        e < t
          ? t + this.gap * (this.left_blocks.length - 1)
          : e + this.gap * (this.right_blocks.length - 1);
    this.masonry_container.style.height = a + 1 + "px";
  }
  getColumnHeight(t) {
    return Math.ceil(
      [...t].reduce((t, e) => t + e.getBoundingClientRect().height, 0)
    );
  }
  resizeObserver() {
    new ResizeObserver(() => this.setMasonryLayout()).observe(
      this.masonry_container
    );
  }
}
const productMediaEl = customElements.get("product-media-variants");
productMediaEl || customElements.define("product-media-variants", ProductMedia);

document.addEventListener("DOMContentLoaded", function() {
    // Get the value of the input field with id "selected_color"
    const selectedColorInput = document.getElementById('selected_color');
    const variant_color = selectedColorInput.value;

    // Get all elements with class .product-media--root
    const productMediaElements = document.querySelectorAll('.product-media--root');
   const productThumbElements = document.querySelectorAll('.product-media--thumb');

    // Loop through each element
    productMediaElements.forEach(element => {
        const dataMediaAltValue = element.getAttribute('data-media-alt');

        // Check if the data-media-alt value matches the variant_color
      if (variant_color != "" && variant_color != null){
        if (dataMediaAltValue === variant_color) {
            // Show the element
            element.style.display = 'block';
        } else {
            // Hide the element
            element.style.display = 'none';
        }
      }
      else{
        element.style.display = 'block';
      }
    });
  productThumbElements.forEach(element => {
        const dataThumbAltValue = element.getAttribute('data-media-alt');

        // Check if the data-media-alt value matches the variant_color
      if (variant_color != "" && variant_color != null){
        if (dataThumbAltValue === variant_color) {
            // Show the element
            element.style.display = 'block';
        } else {
            // Hide the element
            element.style.display = 'none';
        }
      }
      else{
        element.style.display = 'block';
      }
    });
});
